import { Sparkles } from "lucide-react";

export function IntelligencePage() {
  return (
    <section className="view workspace-empty-view" aria-label="智能">
      <div className="workspace-empty-panel">
        <span className="workspace-empty-icon" aria-hidden="true">
          <Sparkles size={22} />
        </span>
        <h2>智能</h2>
        <p>智能页边界已就绪，入口和业务能力将在产品方案明确后接入。</p>
      </div>
    </section>
  );
}
